import { PVRMatrix4x4, PVRVector3, PVRVector4 } from "./webgl/Tools/PVRMaths";
import {PVRPrint3D, EPVRPrint3D} from "./webgl/Tools/PVRPrint3D"
import PVRPFXParser from "./webgl/Tools/PVREffectParser"
import {PVRPFXEffect, EPVRTPFXUniformSemantic } from "./webgl/Tools/PVREffect"
import PVRTexture from "./webgl/Tools/PVRTexture"
import PVRSkybox from './webgl/Tools/PVRSkybox'
import {PVRPODLoader, EPODErrorCodes } from "./webgl/Tools/PVRPODLoader"
import PVRFileStream from "./webgl/Tools/PVRFileStream"
import PVRModel from "./webgl/Tools/PVRModel"
// /******************************************************************************

//  @File         WebGLSkybox2.prototype..cpp

//  @Title        Introducing the POD 3d file format

//  @Version       @Version      

//  @Copyright    Copyright (c) Imagination Technologies Limited.

//  @Platform     Independant

//  @Description  Shows how to load POD files and play the animation with basic
//                lighting

// ******************************************************************************/
// #include <string.h>
// #include <math.h>

// #include "PVRShell.h"
// #include "OGLES2Tools.h"

/******************************************************************************
 Constants
******************************************************************************/

const PVR_SUCCESS = true;
const PVRTEX_CUBEMAP = 1<<12;
const PVRT_PI_OVER_TWO =  (3.1415926535 / 2.0);
const PVRT_PI = 3.1415926535;

const WebGLSkybox2 = function(data){




let documentData = data
   
let dataResult = function(thisdata, a, b)  {
     
    return   thisdata.filter(function(elt)  {
        return elt.endsWith(b) && elt.includes(a)
    })[0]
    }


const myresult = (documentData.allFile.edges.map((file, index) => {return (file.node.publicURL ) }))


let getFileLocation = function(name) {
	const dataResult = function(thisdata, a, b)  {
		return   thisdata.filter(function(elt)  {
			return elt.endsWith(b) && elt.includes(a)
		})[0]
		}
		let r1 = name.split(".")
		let l   = r1.length;
		let filename = r1[0];
		for (let i =1; i<l-1; i++) filename += r1[i];
		//let result = data.allFile.edges.map((file, index) => {return (file.node.publicURL ) })
			return (
				dataResult(myresult, r1[0],r1[l-1])
			)
		}




  
const  g_fFrameRate = 1.0 / 30.0;
const  g_ui32NoOfEffects = 8;  //unsigned int
const g_ui32TexNo = 5;  // unsigned int

const  g_bBlendShader= [
	false,
	false,
	false,
	false,
	true,
	false,
	false,
	true
];

/******************************************************************************
 Content file names
******************************************************************************/

// POD scene files
const  c_szSceneFile = "Scene.pod";

// Textures
const g_aszTextureNames = [
	"Balloon.pvr",
	"Balloon_pvr.pvr",
	"Noise.pvr",
	"MySkybox.pvr",
	"MySkyboxMidnight.pvr"
];

// PFX file
const g_pszEffectFileName = "effects.pfx";

/*!****************************************************************************
 Class implementing the PVRShell functions.
******************************************************************************/

	// Print3D class used to display text
	let	m_Print3D = new PVRPrint3D(myresult);

	// IDs for the various textures
	

	// 3D Model
	//let	m_Scene = null//new CPVRTModelPOD();

	// Projection and Model View matrices
    let 	m_mProjection = new PVRMatrix4x4();
    let m_mView = new PVRMatrix4x4();

	// Variables to handle the animation in a time-based manner
	let 	m_iTimePrev = 0 //unsigned long
	let 		m_fFrame = 0.0 

	// The effect currently being displayed
	let m_i32Effect = 0;

	// The Vertex buffer object handle array.
	
	let	m_iSkyVboID = {}

	/* View Variables */
	let fViewAngle = PVRT_PI_OVER_TWO;
    let fViewDistance = 100.0;
    let fViewAmplitude = 60.0;
    let fViewAmplitudeAngle = 0.0;
    let fViewUpDownAmplitude = 50.0;
    let fViewUpDownAngle = 0.0;

	/* Vectors for calculating the view matrix and saving the camera position*/
    let vTo = new PVRVector3(0,0,0);
    let vUp = new PVRVector3(0,1,0);
    let vCameraPosition = new PVRVector3();

	//animation
	let fBurnAnim =0.0;

	let bPause = false;
	let fDemoFrame = 0.0;

	// The variables required for the effects
	let	m_pEffectParser = null;// new PVRPFXParser(0);
	let	m_ppEffects = [];//new PVRPFXEffect(0);
	
	

	// virtual bool InitApplication();
	// virtual bool InitView();
	// virtual bool ReleaseView();
	// virtual bool QuitApplication();
	// virtual bool RenderScene();

	//void DrawMesh(SPODMesh* mesh);
	//void computeViewMatrix();
//	void DrawSkybox();
//	bool loadEffect(CPVRTPFXEffect **ppEffect, const char * pszEffectName, const char *pszFileName);
//	bool LoadTextures(CPVRTString* const pErrorStr);
//	bool DestroyEffect(CPVRTPFXEffect **ppEffect);
	//void changeSkyboxTo(CPVRTPFXEffect *pEffect, GLuint ui32NewSkybox);


    let loadPOD = function(stream, demo, gl)
    {
		demo.m_Scene = new PVRModel();
		let podLoader    = new PVRPODLoader();
		let result       = podLoader.load(stream, demo.m_Scene);
		if(result !== EPODErrorCodes.eNoError)
		{
			alert("Failed to load POD: " + result);
			return;
		}



        // Create Geometry Buffer Objects.
	// new Array(m_Scene.nNumMeshNode);
    //for (let i =0; i< demo.m_Scene. nNumMeshNode; i++)  demo.m_aiVboID[i] = gl.createBuffer();
    for (let i =0; i< demo.m_Scene.data.numMeshNodes; i++)  demo.m_aiVboID[i] = gl.createBuffer();
	for (let i =0; i< demo.m_Scene.data.numMeshNodes; i++)  demo.m_aiIboID[i] = gl.createBuffer();

	for(let i = 0; i < demo.m_Scene.data.numMeshNodes ; ++i)
	{
		let pNode = demo.m_Scene.data.nodes[i]; //SPODNode*

		// Gets pMesh referenced by the pNode
	     let pMesh = demo.m_Scene.data.meshes[pNode.data.index];  //	SPODMesh*

		// Genereta a vertex buffer and set the interleaved vertex datas.
		gl.bindBuffer(gl.ARRAY_BUFFER, demo.m_aiVboID[i]);
		gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, demo.m_aiIboID[i]);
      //  gl.bufferData(gl.ARRAY_BUFFER, pMesh.sVertex.nStride*pMesh.nNumVertex, pMesh.pInterleaved, gl.STATIC_DRAW);
		 gl.bufferData(gl.ARRAY_BUFFER, pMesh.data.vertexElementData[0], gl.STATIC_DRAW);
		 gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, pMesh.data.faces.data, gl.STATIC_DRAW);
		
    }
	gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, null);
	gl.bindBuffer(gl.ARRAY_BUFFER, null);



	//console.log(demo.m_Scene.data);
        // // Retrieve node indexes
	    // for(let i = 0; i < ENodeNames.eNODE_SIZE; ++i)
	    // {
		//     for(let j = 0; j < demo.Mesh.data.numNodes; ++j)
		//     {
		// 	    let node = demo.Mesh.data.nodes[j];
		// 	    if(node.data.name == c_aszNodeNames[i])
		// 	    {
		// 		    demo.NodeIndexName[j] = i;
		// 		    demo.NodeNameIndex[i] = j;
		//     	}
		//     }
	    // }

        // Set light direction
       // demo.vLightDirection = demo.Mesh.getLightDirection(0);

        demo.MeshesLoadFinished = 0;
    }
/*!****************************************************************************
 @Function		InitApplication
 @Return		bool		true if no error occurred
 @Description	Code in InitApplication() will be called by PVRShell once per
				run, before the rendering context is created.
				Used to initialize variables that are not dependent on it
				(e.g. external modules, loading meshes, etc.)
				If the rendering context is lost, InitApplication() will
				not be called again.
******************************************************************************/
WebGLSkybox2.prototype.initApplication = function(PVRShell)
{
	this.hello = 0;
    this.m_ui32TextureIDs =  new Array(5);  //GLuint
	this.LoadingTextures = 5;
	this.LoadingEffects = true;
    this.m_Scene = null;
    this.MeshesLoadFinished = 1;
	this.m_aiVboID = []; 
	this.m_aiIboID = []; 
	// Get and set the read path for content files
//	CPVRTResourceFile::SetReadPath((char*)PVRShellGet(prefReadPath));

	// Get and set the load/release functions for loading external files.
	// In the majority of cases the PVRShell will return NULL function pointers implying that
	// nothing special is required to load external files.
//	CPVRTResourceFile::SetLoadReleaseFunctions(PVRShellGet(prefLoadFileFunc), PVRShellGet(prefReleaseFileFunc));

	// Load the scene
	// if (m_Scene.ReadFromFile(c_szSceneFile) !== PVR_SUCCESS)
	// {
	// 	console.error( "ERROR: Couldn't load the .pod file\n");
	// 	return false;
	// }

  

	return true;
}

/*!****************************************************************************
 @Function		QuitApplication
 @Return		bool		true if no error occurred
 @Description	Code in QuitApplication() will be called by PVRShell once per
				run, just before exiting the program.
				If the rendering context is lost, QuitApplication() will
				not be called.
******************************************************************************/
 WebGLSkybox2.prototype.quitApplication = function()
{
	// Frees the memory allocated for the scene
	//m_Scene.destroy();

    return true;
}

/*!***************************************************************************
@Function		LoadTextures
@Input			pErrorStr
@Return			bool	
@Description	Loads all of the required textures.
*****************************************************************************/
WebGLSkybox2.prototype.loadTextures = function(gl)
{

  
	for(let i = 0; i < 3; ++i)
	{
        
        (function( i, demo)
	{
		
		PVRTexture.loadFromURI(gl, getFileLocation( g_aszTextureNames[i]), 0,
			function(gl, id, h, m)
			{
		
				demo.m_ui32TextureIDs[i] = id;
				//Clear the bit that denotes that this texture is loaded
				demo.LoadingTextures  -= 1;//&= ~(1<<1);
			
                if(gl.getError()) { alert("Error while loading texture!"); }
                 gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR_MIPMAP_NEAREST);
                 gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
        
	// 			gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
	// gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
	// gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
	// gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
			
			});
	})(i, this);
        
        // if(PVRTexture.LoadFromPVR(g_aszTextureNames[i], m_ui32TextureIDs[i]) !== PVR_SUCCESS)
		// 	return false;

		// gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR_MIPMAP_NEAREST);
        // gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
        



	}

	// Load cube maps
	for(let i = 3; i < 5; ++i)
	{



        (function(gl,i,  demo)
        {
    
            
           
            PVRTexture.loadFromURI(gl,getFileLocation( g_aszTextureNames[i]), 0,
                function(gl, id, h, m)
                {
                  
                    demo.m_ui32TextureIDs[i] = id;
                    //Clear the bit that denotes that this texture is loaded
                    demo.LoadingTextures -=1; //&= ~(1<<0);
                    
                    if(gl.getError()) { alert("Error while loading texture!"); }
        gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_MIN_FILTER, gl.LINEAR_MIPMAP_LINEAR);
		gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
		gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);

                    // gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_MIN_FILTER, gl.LINEAR_MIPMAP_NEAREST);
                    // gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
                    // gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
                    // gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
                    
                });
        })(gl, i, this);

		// if(PVRTTextureLoadFromPVR(g_aszTextureNames[i], m_ui32TextureIDs[i]))
		// {
		// 	//*pErrorStr = CPVRTString("ERROR: Could not open texture file ") + g_aszTextureNames[i];
		// 	return false;
		// }

	
        



	}

	return true;
}





WebGLSkybox2.prototype.loadEffects = function(gl)
{
	
	m_pEffectParser = new PVRPFXParser();
	(function(gl, demo){
	m_pEffectParser.parseFromFile(gl, demo, getFileLocation(g_pszEffectFileName), function(gl,demo){

	 m_ppEffects = new  Array(g_ui32NoOfEffects);
	 for(let i = 0 ; i < g_ui32NoOfEffects; i++ ) m_ppEffects[i] = new PVRPFXEffect();
	 //CPVRTPFXEffect*[g_ui32NoOfEffects];
	 //memset(m_ppEffects, 0, sizeof(CPVRTPFXEffect) * g_ui32NoOfEffects);

	 // Skybox shader
	 if(!demo.loadEffect(gl, m_ppEffects[0], "skybox_effect", getFileLocation(g_pszEffectFileName)))
	 {
		alert("failed");
		  m_pEffectParser = null;
		  m_ppEffects = null;
		 return false;
	 }

	 // The Balloon Shaders
		 if(!demo.loadEffect(gl, m_ppEffects[1], "balloon_effect1", getFileLocation(g_pszEffectFileName)) ||
		 !demo.loadEffect(gl, m_ppEffects[2], "balloon_effect2", getFileLocation(g_pszEffectFileName)) ||
		 !demo.loadEffect(gl, m_ppEffects[3], "balloon_effect3", getFileLocation(g_pszEffectFileName)) ||
		 !demo.loadEffect(gl, m_ppEffects[4], "balloon_effect4", getFileLocation(g_pszEffectFileName)) ||
		 !demo.loadEffect(gl, m_ppEffects[5], "balloon_effect5", getFileLocation(g_pszEffectFileName)) ||
		 !demo.loadEffect(gl, m_ppEffects[6], "balloon_effect6", getFileLocation(g_pszEffectFileName)) ||
		 !demo.loadEffect(gl, m_ppEffects[7], "balloon_effect7", getFileLocation(g_pszEffectFileName)))
	 {
		 alert("failed2");
		  m_pEffectParser = null;
		  m_ppEffects = null;
		  return false;

	 }
	
	

	 })
		
	})(gl, this)
}
/*!****************************************************************************
 @Function		InitView
 @Return		bool		true if no error occurred
 @Description	Code in InitView() will be called by PVRShell upon
				initialization or after a change in the rendering context.
				Used to initialize variables that are dependent on the rendering
				context (e.g. textures, vertex buffers, etc.)
******************************************************************************/
WebGLSkybox2.prototype.initView = function(gl,PVRShell)
{
	// Sets the clear colour
	gl.clearColor(0.6, 0.8, 1.0, 1.0);

	// Enables depth test using the z-buffer
	gl.enable(gl.DEPTH_TEST);

	//CPVRTString ErrorStr;


    (function(demo, gl)
    {
        let fs = new PVRFileStream();
        fs.Open(getFileLocation( c_szSceneFile), true, loadPOD, demo, gl);
    })(this, gl);

	/*
		Load textures
	*/
	if(!this.loadTextures(gl))
	{
		//PVRShellSet(prefExitMessage, ErrorStr.c_str());
		return false;
	}

	/*********************/
	/* Create the Skybox */
	/*********************/
	let skyboxVertices = {};  //float*
    //let skyboxUVs = [];  	//float*

//	PVRTCreateSkybox( 500.0, true, 512, skyboxVertices, skyboxUVs );
    let data = new PVRSkybox(500.0, true, 512);	
    skyboxVertices  = data;

	m_iSkyVboID = gl.createBuffer();
	gl.bindBuffer(gl.ARRAY_BUFFER, m_iSkyVboID);
   //	gl.bufferData(gl.ARRAY_BUFFER, sizeof(glfloat)*3*24, pSkyboxVertices, gl.STATIC_DRAW);
   //   gl.bufferData(gl.ARRAY_BUFFER, 4*3*24, pSkyboxVertices, gl.STATIC_DRAW);
gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(skyboxVertices), gl.STATIC_DRAW);
gl.bindBuffer(gl.ARRAY_BUFFER,null)


//	m_iSkyVboID = gl.createBuffer();
	// gl.bindBuffer(gl.ARRAY_BUFFER, m_iSkyVboID);
	// gl.bufferData(gl.ARRAY_BUFFER, 4 * 3 * 24, skyboxVertices[0], gl.STATIC_DRAW);
	// gl.bindBuffer(gl.ARRAY_BUFFER, null);

	//PVRTDestroySkybox(skyboxVertices, skyboxUVs);

	/**********************/
	/* Create the Effects */
	/**********************/

		// Parse the file
		

		// m_pEffectParser = new PVRPFXParser();


        // (function(gl, demo){

		// m_pEffectParser.parseFromFile(gl, demo, g_pszEffectFileName, function(gl,demo){

       

		//  m_ppEffects = new  Array(g_ui32NoOfEffects);
		//  for(let i = 0 ; i < g_ui32NoOfEffects; i++ ) m_ppEffects[i] = new PVRPFXEffect();
		//  //CPVRTPFXEffect*[g_ui32NoOfEffects];
		//  //memset(m_ppEffects, 0, sizeof(CPVRTPFXEffect) * g_ui32NoOfEffects);
 
		//  // Skybox shader
		//  if(!demo.loadEffect(gl, m_ppEffects[0], "skybox_effect", g_pszEffectFileName))
		//  {
		// 	alert("failed");
		// 	  m_pEffectParser = null;
		// 	  m_ppEffects = null;
		// 	 return false;
		//  }
 
		//  // The Balloon Shaders
		// 	 if(!demo.loadEffect(gl, m_ppEffects[1], "balloon_effect1", g_pszEffectFileName) ||
		// 	 !demo.loadEffect(gl, m_ppEffects[2], "balloon_effect2", g_pszEffectFileName) ||
		// 	 !demo.loadEffect(gl, m_ppEffects[3], "balloon_effect3", g_pszEffectFileName) ||
		// 	 !demo.loadEffect(gl, m_ppEffects[4], "balloon_effect4", g_pszEffectFileName) ||
		// 	 !demo.loadEffect(gl, m_ppEffects[5], "balloon_effect5", g_pszEffectFileName) ||
		// 	 !demo.loadEffect(gl, m_ppEffects[6], "balloon_effect6", g_pszEffectFileName) ||
		// 	 !demo.loadEffect(gl, m_ppEffects[7], "balloon_effect7", g_pszEffectFileName))
		//  {
		// 	 alert("failed");
		// 	  m_pEffectParser = null;
		// 	  m_ppEffects = null;
		// 	  return false;

		//  }
		
		

		//  })
			
	    // })(gl, this)
			
		
       
	

	

	/**********************
	** Projection Matrix **
	**********************/
	/* Projection */
	//let bRotate = false;//PVRShellGet(prefIsRotated) && PVRShellGet(prefFullScreen);
	//m_mProjection = PVRTMat4::PerspectiveFovRH(PVRT_PI / 6, (float) PVRShell.data.width Get(prefWidth) / (float) PVRShellGet(prefHeight), 4.0f, 1000.0f, PVRTMat4::OGL, bRotate);
    m_mProjection = PVRMatrix4x4.createPerspectiveProjection(4.0, 1000.0, PVRT_PI / 6,  PVRShell.data.width /  PVRShell.data.height  );

	// Calculate the model view matrix turning around the balloon
	this.computeViewMatrix();

	/* Init Values */
	bPause = false;
	fDemoFrame = 0.0;
	fBurnAnim = 0.0;

	m_i32Effect = 1;

	// Initialise Print3D
	//if(m_Print3D.SetTextures(0,PVRShell.data.width,  Get(prefWidth),PVRShellGet(prefHeight), bRotate) != PVR_SUCCESS)
    
    m_Print3D.setTextures(gl, PVRShell.data.width, PVRShell.data.height)
    // {
	// 	//PVRShellSet(prefExitMessage, "ERROR: Cannot initialise Print3D\n");
	// 	return false;
	// }

	// Initialise variables used for the animation
	m_iTimePrev = PVRShell.getTimeNow();

	return true;
}

/*!***************************************************************************
@Function		loadEffect
@Output			ppEffect
@Input			pszEffectName
@Input			pszFileName
@Return			bool	
@Description	Loads a PFX Effect.
*****************************************************************************/
// WebGLSkybox2.prototype.loadEffect = function( CPVRTPFXEffect **ppEffect, const char * pszEffectName, const char *pszFileName )
WebGLSkybox2.prototype.loadEffect = function(gl, ppEffect,   pszEffectName, pszFileName )

 {
	
// 	if(!ppEffect) return false;

	let	nUnknownUniformCount = 0;//unsigned int
// 	//CPVRTString		error;
// //let pEffect = ppEffect; //	CPVRTPFXEffect* 

// 	// Load an effect from the file
// 	if(!pEffect)
// 	{
// 		alert("new");
// 		ppEffect = new PVRPFXEffect();
// 		pEffect   = ppEffect;
// 		if(!pEffect)
// 		{
// 			 m_pEffectParser = null;
// 			console.error("Failed to create effect.\n");
// 			return false;
// 		}
// 	}


	if(ppEffect.load(gl, m_pEffectParser, pszEffectName, pszFileName, null, nUnknownUniformCount, function(gl,demo){
 

		if(nUnknownUniformCount)
	{
		//PVRShellOutputDebug(error.c_str());
		console.error("Unknown uniform semantic count: %d\n", nUnknownUniformCount);
	}

	/* Set the textures for each effect */
		//i,j ;
	const sTex = ppEffect.getTextureArray(); //CPVRTArray<SPVRTPFXTexture>& 




	for(let i = 0; i < sTex.length; ++i)
	{
		
		for(let j = 0; j < g_ui32TexNo; ++j)
		{
		
			
			let iTexIdx = m_pEffectParser.findTextureByName(sTex[i].name);
			const FileName = m_pEffectParser.getTexture(iTexIdx).fileName;  //CPVRTStringHash& 
			if(FileName === g_aszTextureNames[j])
			{
			
				if(j === 3 || j === 4){
				
				ppEffect.setTexture(gl, i, demo.m_ui32TextureIDs[j], PVRTEX_CUBEMAP);}
				else
				ppEffect.setTexture(gl ,i, demo.m_ui32TextureIDs[j]);
				break;
			}

		}
	}

demo.MeshesLoadFinished--;

	}, this) !== PVR_SUCCESS)
	{
		//PVRShellSet(prefExitMessage, error.c_str());
		return false;
	}

	

	return true;
}

/*!***************************************************************************
@Function		DestroyEffect
@Output			ppEffect
@Return			bool	
@Description	Deletes an effect and releases resources.
*****************************************************************************/
 WebGLSkybox2.prototype.destroyEffect = function (gl, ppEffect)
// WebGLSkybox2.prototype.DestroyEffect(CPVRTPFXEffect **ppEffect)
{
	if(ppEffect)
	{
		
			const sTex = ppEffect.getTextureArray(); //CPVRTArray<SPVRTPFXTexture>& 

			for(let i = 0; i < sTex.length; ++i)
			{
				gl.deleteTextures(sTex[i].ui);
			}

			ppEffect = null
		
		
	}

	return true;
}

/*!****************************************************************************
 @Function		ReleaseView
 @Return		bool		true if no error occured
 @Description	Code in ReleaseView() will be called by PVRShell when the
				application quits or before a change in the rendering context.
******************************************************************************/
//</SPVRTPFXTexture> WebGLSkybox2.prototype.::ReleaseView()
 WebGLSkybox2.prototype.releaseView = function(gl)
{
	// Free the textures
	//unsigned int i;

	for( let i = 0; i < g_ui32TexNo ; ++i)
	{
		gl.deleteTexture(this.m_ui32TextureIDs[i]);
	}

	// Release Print3D Textures
	m_Print3D.releaseTextures();

	// Release Vertex buffer objects.
    this.m_aiVboID.forEach(x=>   gl.deleteBuffer(x));//  gl.deleteBuffers(m_Scene.nNumMeshNode, this.m_aiVboID);
    this.m_aiIboID.forEach(x=>   gl.deleteBuffer(x));//  gl.deleteBuffers(m_Scene.nNumMeshNode, this.m_aiVboID);
    
	gl.deleteBuffer(m_iSkyVboID);
	 this.m_aiVboID = null;
	 this.m_aiIboID = null;

	// Destroy the effects
	for(let i = 0; i < g_ui32NoOfEffects; ++i) this.destroyEffect(m_ppEffects[i]);

 m_ppEffects = null;
 m_pEffectParser = null;

	return true;
}

/*!****************************************************************************
 @Function		RenderScene
 @Return		bool		true if no error occurred
 @Description	Main rendering loop function of the program. The shell will
				call this function every frame.
				eglSwapBuffers() will be performed by PVRShell automatically.
				PVRShell will also manage important OS events.
				Will also manage relevant OS events. The user has access to
				these events through an abstraction layer provided by PVRShell.
******************************************************************************/
//</SPVRTPFXTexture>bool WebGLSkybox2.prototype.::RenderScene()
 WebGLSkybox2.prototype.renderScene = function( gl, PVRShell)
{


   //console.log(this.MeshesLoadFinished);

	if (this.LoadingTextures > 0) {return true;}
	
	if(this.MeshesLoadFinished > 0) { return true;}

	if (this.LoadingEffects) {
		this.LoadingEffects = false;
		this.loadEffects(gl);
	}
	
	if(this.MeshesLoadFinished > -8) { return true;}


	// Clears the colour and depth buffer
	gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT);

	/*
		Calculates the frame number to animate in a time-based manner.
		Uses the shell function PVRShellGetTime() to get the time in milliseconds.
	*/

	let iTime = PVRShell.getTimeNow();

	if(!bPause)
	{
		// Calculate the model view matrix turning around the balloon
		this.computeViewMatrix();

		if(iTime > m_iTimePrev)
		{
			let fDelta =  (iTime - m_iTimePrev) * g_fFrameRate;
			m_fFrame   += fDelta;
			fDemoFrame += fDelta;
			fBurnAnim  += fDelta * 0.02;

			if(fBurnAnim >= 1.0)
				fBurnAnim = 1.0;
		}
	
	}

	m_iTimePrev	= iTime;

	/* KeyBoard input processing */

	if(PVRShell.isKeyPressed(PVRShell.KeyNameACTION1))
		bPause=!bPause;

	if(PVRShell.isKeyPressed(PVRShell.KeyNameACTION2))
		fBurnAnim = 0.0;

	/* Keyboard Animation and Automatic Shader Change over time */
	if(!bPause && (fDemoFrame > 500 || (m_i32Effect === 2 && fDemoFrame > 80)))
	{
		this.changeSkyboxTo(m_ppEffects[m_i32Effect], this.m_ui32TextureIDs[3]);
		if(++m_i32Effect >= g_ui32NoOfEffects)
		{
			m_i32Effect = 1;
			m_fFrame = 0.0;
		}

		fDemoFrame = 0.0;
		fBurnAnim  = 0.0;
	}

	/* Change Shader Effect */

	 if(PVRShell.isKeyPressed(PVRShell.KeyNameRIGHT))
	 {
	 	if(++m_i32Effect >= g_ui32NoOfEffects)
	 		m_i32Effect = 1;

	 	fDemoFrame = 0.0;
	 	fBurnAnim  = 0.0;
		m_fFrame = 0.0;
	}
	if(PVRShell.isKeyPressed(PVRShell.KeyNameLEFT))
	{
		if(--m_i32Effect < 1)
			m_i32Effect = g_ui32NoOfEffects - 1;

		fDemoFrame = 0.0;
		fBurnAnim  = 0.0;
		m_fFrame = 0.0;
	}

	/* Change Skybox Texture */
	if(PVRShell.isKeyPressed(PVRShell.KeyNameUP))
	{
		for(let i = 0; i < g_ui32NoOfEffects; ++i)
			this.changeSkyboxTo(m_ppEffects[i], this.m_ui32TextureIDs[4]);

		fBurnAnim = 0.0;
	}

	if(PVRShell.isKeyPressed(PVRShell.KeyNameDOWN))
	{
		for(let i = 0; i < g_ui32NoOfEffects; ++i)
			this.changeSkyboxTo(m_ppEffects[i], this.m_ui32TextureIDs[3]);

		fBurnAnim = 0.0;
	}

	/* Setup Shader and Shader Constants */
	let location = {};

   
	gl.disable(gl.CULL_FACE);

	this.drawSkybox(gl);

	gl.enable(gl.CULL_FACE);



	m_ppEffects[m_i32Effect].activate(gl);


	//for(let i = 0; i <this.m_Scene.nNumMeshNode; i++)
    for(let i = 0; i <this.m_Scene.data.numMeshNodes; i++)
    {
		let pNode = this.m_Scene.data.nodes[i]; //SPODNode* 

		// Gets pMesh referenced by the pNode
	let	pMesh = this.m_Scene.data.meshes[pNode.data.index];  //SPODMesh* 

		// Gets the node model matrix
		//PVRMatrix4x4() mWorld, mWORLDVIEW;
	let	mWorld =this.m_Scene.getWorldMatrix(pNode.data.index);
  

	let	mWORLDVIEW =  PVRMatrix4x4.matrixMultiply( m_mView , mWorld);

		gl.bindBuffer(gl.ARRAY_BUFFER, this.m_aiVboID[i]);
		gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, this.m_aiIboID[i]);

    
		const uniforms = m_ppEffects[m_i32Effect].getUniformArray();  //CPVRTArray<SPVRTPFXUniform>& 
	
   
		let positions = pMesh.data.vertexElements["POSITION0"];
        let normals   = pMesh.data.vertexElements["NORMAL0"];
        let uvs       = pMesh.data.vertexElements["UV0"];





		for(let j = 0; j < uniforms.length; ++j)
		{
		
			switch(uniforms[j].nSemantic)
			{
				case EPVRTPFXUniformSemantic.ePVRTPFX_UsPOSITION:
			
					//gl.vertexAttribPointer(uniforms[j].nLocation, 3, gl.FLOAT, gl.FALSE, pMesh.sVertex.nStride, pMesh.sVertex.pData);
					gl.vertexAttribPointer(uniforms[j].nLocation, positions.numComponents, gl.FLOAT, gl.FALSE, positions.stride, positions.offset);
					gl.enableVertexAttribArray(uniforms[j].nLocation);
				
				break;
				case EPVRTPFXUniformSemantic.ePVRTPFX_UsNORMAL:
				
					//gl.vertexAttribPointer(uniforms[j].nLocation, 3, gl.FLOAT, gl.FALSE, pMesh.sNormals.nStride, pMesh.sNormals.pData);
					gl.vertexAttribPointer(uniforms[j].nLocation, normals.numComponents, gl.FLOAT, gl.FALSE, normals.stride, normals.offset);
					gl.enableVertexAttribArray(uniforms[j].nLocation);
				
				break;
				case EPVRTPFXUniformSemantic.ePVRTPFX_UsUV:
			
				//	gl.vertexAttribPointer(uniforms[j].nLocation, 2, gl.FLOAT, gl.FALSE, pMesh.psUVW[0].nStride, pMesh.psUVW[0].pData);
				gl.vertexAttribPointer(uniforms[j].nLocation, uvs.numComponents, gl.FLOAT, gl.FALSE, uvs.stride, uvs.offset);
				gl.enableVertexAttribArray(uniforms[j].nLocation);
				
				break;
				case EPVRTPFXUniformSemantic.ePVRTPFX_UsWORLDVIEWPROJECTION:
				
					//PVRTMat4 mMVP;

					/* Passes the model-view-projection matrix (MVP) to the shader to transform the vertices */
					let mMVP = PVRMatrix4x4.matrixMultiply(  m_mProjection , mWORLDVIEW);
					gl.uniformMatrix4fv(uniforms[j].nLocation,  gl.FALSE, mMVP.data);
				
				break;
				case EPVRTPFXUniformSemantic.ePVRTPFX_UsWORLDVIEW:
				
					gl.uniformMatrix4fv(uniforms[j].nLocation,  gl.FALSE, mWORLDVIEW.data);
				
				break;
				case EPVRTPFXUniformSemantic.ePVRTPFX_UsWORLDVIEWIT:
				
					//PVRTMat4 mWORLDVIEWI, mWORLDVIEWIT;

					let mWORLDVIEWI =  PVRMatrix4x4.inverse(  mWORLDVIEW) ;//.inverse();
					let mWORLDVIEWIT=    PVRMatrix4x4.transpose( mWORLDVIEWI); //.transpose();

					let WORLDVIEWIT = PVRMatrix4x4.createMatrix3x3(mWORLDVIEWIT);  //PVRTMat3

					gl.uniformMatrix3fv(uniforms[j].nLocation,  gl.FALSE, WORLDVIEWIT.data);
				
				break;
				case EPVRTPFXUniformSemantic.ePVRTPFX_UsVIEWIT:
				
					//PVRTMat4 mViewI, mViewIT;
					alert("transpose2")
					let mViewI  = PVRMatrix4x4.inverse( m_mView); //.inverse();
					let mViewIT = PVRMatrix4x4.transpose( mViewI);//.transpose();

					let ViewIT = PVRMatrix4x4.createMatrix3x3(mViewIT); //PVRTMat3

					gl.uniformMatrix3fv(uniforms[j].nLocation, gl.FALSE, ViewIT.data);
				
				break;
				case EPVRTPFXUniformSemantic.ePVRTPFX_UsLIGHTDIREYE:
				
					//let vLightDirectionEyeSpace;

					// Passes the light direction in eye space to the shader
					let vLightDirectionEyeSpace = PVRMatrix4x4.multiply(  m_mView , new PVRVector4(1.0,1.0,-1.0,0.0));
					gl.uniform3f(uniforms[j].nLocation, vLightDirectionEyeSpace.data[0] , vLightDirectionEyeSpace.data[1] , vLightDirectionEyeSpace.data[2] );
		
				break;
				case EPVRTPFXUniformSemantic.ePVRTPFX_UsTEXTURE:
				
					// Set the sampler variable to the texture unit
					gl.uniform1i(uniforms[j].nLocation, uniforms[j].nIdx);
				
                break;
                default: break;
			}
		}

		location = gl.getUniformLocation(m_ppEffects[m_i32Effect].getProgramHandle(), "myEyePos");

		if(location !== null) gl.uniform3f(location, vCameraPosition.data[0] , vCameraPosition.data[1] , vCameraPosition.data[2] );

		//set animation
		location = gl.getUniformLocation(m_ppEffects[m_i32Effect].getProgramHandle(), "fAnim");

		if(location !== null)
			gl.uniform1f(location, fBurnAnim);

		location = gl.getUniformLocation(m_ppEffects[m_i32Effect].getProgramHandle(), "myFrame");

		if(location !== null)
			gl.uniform1f(location, m_fFrame);
    
		if(g_bBlendShader[m_i32Effect])
		{
			gl.enable(gl.BLEND);

			// Correct render order for alpha blending through culling
			// Draw Back faces
			gl.cullFace(gl.FRONT);

			location = gl.getUniformLocation(m_ppEffects[m_i32Effect].getProgramHandle(), "bBackFace");

			gl.uniform1i(location, 1);

			this.drawMesh(gl, pMesh);

			gl.uniform1i(location, 0);

			gl.cullFace(gl.BACK);
		}
		else
		{
        	location = gl.getUniformLocation(m_ppEffects[m_i32Effect].getProgramHandle(), "bBackFace");

			if(location !== null)
				gl.uniform1i(location, 0);

			gl.disable(gl.BLEND);
		}
    
		/* Everything should now be setup, therefore draw the mesh*/
		this.drawMesh(gl,pMesh);

	
		for(let j = 0; j < uniforms.length; ++j)
		{
			switch(uniforms[j].nSemantic)
			{
			case EPVRTPFXUniformSemantic.ePVRTPFX_UsPOSITION:
				
					gl.disableVertexAttribArray(uniforms[j].nLocation);
				
				break;
			case EPVRTPFXUniformSemantic.ePVRTPFX_UsNORMAL:
				
					gl.disableVertexAttribArray(uniforms[j].nLocation);
				
				break;
			case EPVRTPFXUniformSemantic.ePVRTPFX_UsUV:
				
					gl.disableVertexAttribArray(uniforms[j].nLocation);
				
				break;
            default: break;
            }
          }
		
		  gl.bindBuffer(gl.ARRAY_BUFFER, null);
		  gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, null);
  
	}

	// Displays the demo name using the tools. For a detailed explanation, see the training course IntroducingPVRTools
	if(!bPause)
		m_Print3D.displayDefaultTitle("", "", EPVRPrint3D.Logo.PowerVR);
	else
		m_Print3D.displayDefaultTitle("Skybox", "Paused", EPVRPrint3D.Logo.PowerVR);
	m_Print3D.flush(gl);

	return true;
}

/*!****************************************************************************
 @Function		DrawMesh
 @Input			mesh		The mesh to draw
 @Description	Draws a SPODMesh after the model view matrix has been set and
				the meterial prepared.
******************************************************************************/
 WebGLSkybox2.prototype.drawMesh = function(gl, pMesh)
{
	/*
		The geometry can be exported in 4 ways:
		- Non-Indexed Triangle list
		- Indexed Triangle list
		- Non-Indexed Triangle strips
		- Indexed Triangle strips
	*/
	if(pMesh.data.primitiveData.numStrips === 0)
	{
		
		if(1)
		{
			// Indexed Triangle list
			//gl.drawElements(gl.TRIANGLES, pMesh.nNumFaces*3, gl.UNSIGNED_SHORT, pMesh.sFaces.pData);
			gl.drawElements(gl.TRIANGLES, pMesh.data.faces.data.length, gl.UNSIGNED_SHORT, 0);
		//gl.drawElements(gl.TRIANGLES, 6601, gl.UNSIGNED_SHORT, 0);
		
		}
		else
		{
		
			// Non-Indexed Triangl.e list
			//gl.drawArrays(gl.TRIANGLES, 0, pMesh.nNumFaces*3);
			gl.drawArrays(gl.TRIANGLES, 0, pMesh.data.faces.data.length);
         

		}
	}
	else
	{
		// if(pMesh.sFaces.pData)
		// {
		// 	// Indexed Triangle strips
		// 	let offset = 0;
		// 	for(let i = 0; i < pMesh.nNumStrips; i++)
		// 	{
		// 		gl.drawElements(gl.TRIANGLE_STRIP, pMesh.pnStripLength[i]+2, gl.UNSIGNED_SHORT, pMesh.sFaces.pData + offset*2);
		// 		offset += pMesh.pnStripLength[i]+2;
		// 	}
		// }
		// else
		// {
			// Non-Indexed Triangle strips
			// let offset = 0;
			// for(let i = 0; i < pMesh.nNumStrips; i++)
			// {
			// 	gl.drawArrays(gl.TRIANGLE_STRIP, offset, pMesh.pnStripLength[i]+2);
			// 	offset += pMesh.pnStripLength[i]+2;
			// }

			for(let i = 0; i < pMesh.data.primitiveData.numStrips; ++i)
            {
                let offset = 0;
                if(0)
                {
                    // Indexed Triangle strips
                    gl.drawElements(gl.TRIANGLE_STRIP, pMesh.data.primitiveData.stripLengths[i]+2, gl.UNSIGNED_SHORT, (offset*2));
                }
                else
                {
                    // Non-Indexed Triangle strips
                    gl.drawArrays(gl.TRIANGLE_STRIP, offset, pMesh.data.primitiveData.stripLength[i]+2);
                }
                offset += pMesh.data.primitiveData.stripLength[i]+2;
            }






		}
	
}

/*******************************************************************************
 * Function Name  : computeViewMatrix
 * Description    : Calculate the view matrix turning around the balloon
 *******************************************************************************/
 WebGLSkybox2.prototype.computeViewMatrix= function()
{
	let vFrom = new PVRVector3(); //

	/* Calculate the distance to balloon */
	let fDistance = fViewDistance + fViewAmplitude * Math.sin(fViewAmplitudeAngle);
	fDistance = fDistance / 5.0;
	fViewAmplitudeAngle += 0.004;

	/* Calculate the vertical position of the camera */
	let updown = fViewUpDownAmplitude * Math.sin(fViewUpDownAngle);
	updown = updown / 5.0;
	fViewUpDownAngle += 0.005;

	/* Calculate the angle of the camera around the balloon */
	vFrom.data[0] = fDistance *  Math.cos(fViewAngle);
	vFrom.data[1] = updown;
	vFrom.data[2] = fDistance * Math.sin(fViewAngle);
	fViewAngle += 0.003;
	
	
	/* Compute and set the matrix */
	m_mView = PVRMatrix4x4.createLookAt(vFrom, vTo, vUp);

	/* Remember the camera position to draw the Skybox around it */
	vCameraPosition = vFrom;
}

/*!***************************************************************************
@Function		changeSkyboxTo
@Output			pEffect
@Input			ui32NewSkybox
@Description	Changes the skybox to use the selected effect.
*****************************************************************************/
// WebGLSkybox2.prototype.changeSkyboxTo= function(CPVRTPFXEffect *pEffect, GLuint ui32NewSkybox)
 WebGLSkybox2.prototype.changeSkyboxTo= function(pEffect, ui32NewSkybox)
{
	const  sTex = pEffect.getTextureArray();  //CPVRTArray<SPVRTPFXTexture>&

	for(let i = 0; i < sTex.length; ++i)
	{
		let iTexIdx = m_pEffectParser.findTextureByName(sTex[i].name);
		const FileName = m_pEffectParser.getTexture(iTexIdx).fileName; //CPVRTStringHash& 

		if(FileName === g_aszTextureNames[3])
		{
			pEffect.setTexture(i, ui32NewSkybox, PVRTEX_CUBEMAP);
			return;
		}
	}
}

/*******************************************************************************
 * Function Name  : DrawSkybox
 * Description    : Draws the Skybox
 *******************************************************************************/
 WebGLSkybox2.prototype.drawSkybox = function(gl)
{
    // Use the loaded Skybox shader program
    //alert(m_ppEffects);
     m_ppEffects[0].activate(gl);

	let iVertexUniform = 0;

	const  uniforms = m_ppEffects[0].getUniformArray(); //CPVRTArray<SPVRTPFXUniform>&
	
	
	
	for(let  j = 0; j < uniforms.length; ++j)
	{
		
		switch(uniforms[j].nSemantic)
		{
			case EPVRTPFXUniformSemantic.ePVRTPFX_UsPOSITION:
		
				iVertexUniform = j;
				gl.enableVertexAttribArray(uniforms[j].nLocation);
            
			break;
			case EPVRTPFXUniformSemantic.ePVRTPFX_UsWORLDVIEWPROJECTION:
			
				//PVRTMat4 mTrans, mMVP;
			let	mTrans =  PVRMatrix4x4.createTranslation3D(-vCameraPosition.data[0] , -vCameraPosition.data[1] , -vCameraPosition.data[2] )//         PVRTMat4::Translation(-vCameraPosition[0] , -vCameraPosition[1] , -vCameraPosition[2] );
			let	mMVP = PVRMatrix4x4.matrixMultiply( PVRMatrix4x4.matrixMultiply(  m_mProjection , mTrans)  , m_mView);				/* Passes the model-view-projection matrix (MVP) to the shader to transform the vertices */
				gl.uniformMatrix4fv(uniforms[j].nLocation,  gl.FALSE, mMVP.data);
		 
			break;
			case EPVRTPFXUniformSemantic.ePVRTPFX_UsTEXTURE:
			
				// Set the sampler variable to the texture unit
				gl.uniform1i(uniforms[j].nLocation, uniforms[j].nIdx);
			
            break;
            default: break;
		}
	}

	// Draw the skybox
	gl.bindBuffer(gl.ARRAY_BUFFER, m_iSkyVboID);
	 
	//gl.vertexAttribPointer(uniforms[iVertexUniform].nLocation, 3, gl.FLOAT, gl.FALSE, 4*5, 0);
	gl.vertexAttribPointer(0, 3, gl.FLOAT, gl.FALSE, 4*5, 0);
	//gl.vertexAttribPointer(uniforms[iVertexUniform].nLocation, 3, gl.FLOAT, gl.FALSE, 12,  0);
	for (let i = 0; i < 6; ++i)
	{
	// 	// Set Data Pointers
		//let offset = 80 * i;//</SPVRTPFXUniform>sizeof(float) * i*4*3;
	// 	// Draw

		gl.drawArrays(gl.TRIANGLE_STRIP, i*4 , 4);
	}

	/* Disable States */
	gl.disableVertexAttribArray(uniforms[iVertexUniform].nLocation);
    
}

return null;
}


export default WebGLSkybox2




